export const RECEIVE_PRODUCTS = 'RECEIVE_PRODUCTS';
export const SELECT_PRODUCTS = 'SELECT_PRODUCTS';
export const DESELECT_PRODUCTS = 'DESELECT_PRODUCTS';
export const SET_SELECTED_PRODUCT = 'SET_SELECTED_PRODUCT';
